import { SkeletonLoader } from "../../../../../components";

export const BankListSkeleton = () => (
  <div className="cds--structured-list-row">
    <div className="cds--structured-list-td">
      <SkeletonLoader type="icon" />
    </div>

    <div className="cds--structured-list-td">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td">
      <SkeletonLoader type="text" />
    </div>
  </div>
);
